module.exports = __webpack_public_path__ + "static/media/JULD-BNB.25de3444.svg";